import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xing-com/layout-tokens';
import { spaceXXL, spaceL, scale110 } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';
import { Row } from '@xing-com/xing-grid';

export const ContentRow = styled(Row)<{
  $isLoading: boolean;
}>`
  display: flex;
  flex-direction: column-reverse;

  ${({ $isLoading }) => ($isLoading ? 'min-height: 50vh;' : '')};

  @media ${mediaWide} {
    flex-direction: inherit;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-top: 0;
  margin-bottom: ${spaceL};

  font-weight: 700;
  line-height: 1.25;
  font-size: ${scale110};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;
